/// <reference path="../common/sm.portal.vm.account.js" />
/// <reference path="../../smapi.access.js" />
/// <reference path="jquery.blockUI.js" />

(function (jQuery, undefined) {
  var sm = window.sm = window.sm || {};
  var windowProxy;
  var actionQueue = [];

  if (typeof sm.portal === 'undefined') {
    jQuery.extend(sm, { portal: {} });
  }
  if (typeof sm.portal.vm === 'undefined') {
    jQuery.extend(sm.portal, { vm: {} });
  }
  if (typeof sm.portal.vm.continuingEducation === 'undefined') {
    jQuery.extend(sm.portal.vm, { continuingEducation: {} });
  }

  function ContinuingEducationViewModel () {
    var self = this;

    self.PersonModel = new smapi.community.PersonModel();
    self.EmploymentDataItem = new sm.portal.vm.EmploymentDataItem();
    self.AccountViewModel = new sm.portal.vm.AccountViewModel();
    self.DemographicDataModel = new smapi.community.DemographicDataModel();

    self.MailingAddressViewModel = ko.observable(new sm.portal.vm.MailingAddressViewModel());

    // Extra Info that is on this  Cont Edu View Model Only
    self.DateOfBirth = ko.validatedObservable();
    self.TemplatesLoaded = ko.observable(false);
    self.SetupOK = ko.observable(true);

    // Model Error Handling
    self.IsError = ko.observable(false);
    self.ErrorMessage = ko.observable('');
    self.ErrorHeader = ko.observable(sm.portal.utility.getResourceValue('ThereWasAnError'));
    self.ErrorMessages = ko.observableArray();
    self.HandleError = function (title, messages) {
      self.DataLoading(false);
      self.IsError(true);
      if (sm.portal.utility.isNullOrEmpty(title)) {
        self.ErrorHeader(sm.portal.utility.getResourceValue('ThereWasAnError'));
      } else {
        self.ErrorHeader(title);
      }
      self.ErrorMessages(messages);
    };

    self.ClearErrors = function () {
      self.ErrorHeader('');
      self.ErrorMessages.removeAll();
    };

    self.NoAccess = ko.observable(false);

    // BEGIN Properties
    self.Countries = ko.observableArray([]);
    self.GoverningDistricts = ko.observableArray([]);
    self.DataLoading = ko.observable(false);
    self.DataLoading.subscribe(function (dataLoading) {
      if (dataLoading) {
        jQuery.blockUI();
      } else {
        jQuery.unblockUI();
      }
    });

    self.PrimaryEmailAddress = ko.validatedObservable();
    self.ConfirmPersonEmailAddress = ko.validatedObservable();
    self.Genders = ko.observableArray();
    self.EthnicOrigins = ko.observableArray();
    self.EthnicID = ko.observable();
    self.GenderID = ko.observable();
    self.CitizenshipID = ko.observable();
    self.EmploymentStatuses = ko.observableArray();
    self.EmploymentStatusID = ko.observable();
    self.EmployerID = ko.observable();
    self.OccupationID = ko.observable();
    self.Occupation = ko.observable();
    self.CurrentEmployer = ko.validatedObservable();
    self.Occupations = ko.observableArray();

    self.PrimaryEmailAddressID = ko.observable();
    self.PrimaryEmailAddressGID = ko.observable();
    self.PersonID = ko.observable();
    self.PersonGID = ko.observable();
    self.UserID = ko.observable();
    self.LoginUserName = ko.observable();
    self.BaseApiURL = ko.observable();
    self.TemplatesURL = ko.observable();
    self.PersonId = ko.observable('0');
    self.StudentId = ko.observable('0');
    self.HideTaxID = ko.observable(false);
    self.HideHispanic = ko.observable(false);
    self.HideVeteran = ko.observable(false);
    self.HideCurrentEmployerSearch = ko.observable(false);
    self.HideAddressFormat = ko.observable(false);
    self.ResidentState = ko.observable('ResidentState');
    self.TaxIdTemplate = ko.observable('');
    self.CurrentEmployerTemplate = ko.observable('');
    self.AddressFormatTemplate = ko.observable('');
    self.HideCoreFields = ko.observable(false);
    
    sm.portal.vm.custom.setCustomLocalizeKey(self); 

    self.LoadInitialData = function () {
      self.DataLoading(true);
      var url = self.BaseApiURL() + 'api/ContinuingEducation/GetContinuingEducationApplicationData';

      var promise = jQuery.ajax({
        url: url,
        type: 'GET',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        headers: {
          'x-api-version': '1' //, 
        },
        processData: false,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        success: function (data) {
          if (data.Status === 'success' && data.Payload) {
            self.SetupOK(data.Payload.SetupOK);

            // List Data
            if (data.Payload) {
              if (!sm.portal.utility.isNullOrEmpty(data.Payload.EthnicOrigins)) {
                ko.mapping.fromJS(data.Payload.EthnicOrigins, {}, self.EthnicOrigins);
              }

              if (!sm.portal.utility.isNullOrEmpty(data.Payload.AllCountry)) {
                ko.mapping.fromJS(data.Payload.AllCountry, {}, self.Countries);
              }

              if (!sm.portal.utility.isNullOrEmpty(data.Payload.GoverningDistrict)) {
                ko.mapping.fromJS(data.Payload.GoverningDistrict, {}, self.GoverningDistricts);
              }
              if (!sm.portal.utility.isNullOrEmpty(data.Payload.Gender)) {
                ko.mapping.fromJS(data.Payload.Gender, {}, self.Genders);
              }
              if (!sm.portal.utility.isNullOrEmpty(data.Payload.EmploymentStatuses)) {
                ko.mapping.fromJS(data.Payload.EmploymentStatuses, {}, self.EmploymentStatuses);
              }
              if (!sm.portal.utility.isNullOrEmpty(data.Payload.Occupations)) {
                ko.mapping.fromJS(data.Payload.Occupations, {}, self.Occupations);
              }
              // Password infromation
              if (!sm.portal.utility.isNullOrEmpty(data.Payload.PasswordRequirementMessage)) {
                self.AccountViewModel.PasswordRequirementMessage(data.Payload.PasswordRequirementMessage);
              }
              if (!sm.portal.utility.isNullOrEmpty(data.Payload.PasswordRegexPattern)) {
                self.AccountViewModel.PasswordRegex(data.Payload.PasswordRegexPattern);
              }
              if (!sm.portal.utility.isNullOrEmpty(data.Payload.PasswordMinLength)) {
                self.AccountViewModel.PasswordMinLength(data.Payload.PasswordMinLength);
              }

              if (data.Payload.PreexistingData) {
                var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();

                self.PersonModel.GivenName(data.Payload.PreexistingData.GivenName);
                self.PersonModel.MiddleName(data.Payload.PreexistingData.MiddleName);
                self.PersonModel.Surname(data.Payload.PreexistingData.Surname);
                self.PersonModel.GenderID(data.Payload.PreexistingData.GenderID);
                self.PersonModel.DateOfBirth(moment(new Date(data.Payload.PreexistingData.DateOfBirth)).format(dateFormat));
                self.PrimaryEmailAddress(data.Payload.PreexistingData.Email);
                self.ConfirmPersonEmailAddress(data.Payload.PreexistingData.Email);
                if(sm.portal.utility.isCanadaFeatureEnabled()){
                  self.PersonModel.SIN(data.Payload.PreexistingData.TaxID);
                }else{
                  self.PersonModel.TaxID(data.Payload.PreexistingData.TaxID);
                }
                self.DemographicDataModel.CitizenshipID = data.Payload.PreexistingData.Citizenships;
                self.CitizenshipID(data.Payload.PreexistingData.Citizenships);
                self.DemographicDataModel.BirthCountryID(data.Payload.PreexistingData.BirthCountryID);
                self.DemographicDataModel.ResidentStateID(data.Payload.PreexistingData.ResidentStateID);
                self.DemographicDataModel.EthnicOriginIDs = data.Payload.PreexistingData.EthnicOrigins;
                self.DemographicDataModel.IsHispanic(data.Payload.PreexistingData.IsHispanic ? 'true' : 'false');
                self.DemographicDataModel.Veteran(data.Payload.PreexistingData.Veteran ? 'true' : 'false');
                self.EmploymentDataItem.EmploymentStatusID(data.Payload.PreexistingData.EmploymentStatusID);
                self.EmploymentDataItem.OccupationID(data.Payload.PreexistingData.OccupationID);
                self.EmploymentDataItem.EmployerID(data.Payload.PreexistingData.EmployerID);
              }
            }
          }
        },
        complete: function () {
          self.DataLoading(false);
        }
      });
      return promise;
    };

    // END Properties

    this.ExtractATO = function () {
      if (!sm.portal.utility.isNullOrEmpty(self.DemographicDataModel.CitizenshipID) && self.DemographicDataModel.CitizenshipID > 0) {
        var citizenship = new smapi.community.CitizenshipModel({
          CountryID: self.DemographicDataModel.CitizenshipID,
          IsPrimary: true
        });
        self.DemographicDataModel.Citizenships.removeAll();
        self.DemographicDataModel.Citizenships().push(citizenship);
      }

      var mailingAddress = self.MailingAddressViewModel().ExtractATO();
      var atoPerson = self.PersonModel;
      //mailingAddress.CountryID = self.MailingAddressViewModel.SelectedCountryID();
      atoPerson.Addresses.push(mailingAddress);

      var atoModel = {
        Person: atoPerson,
        Email: self.PrimaryEmailAddress(),
        NewAccountPassword: self.AccountViewModel.NewAccountPassword(),
        EmploymentATO: self.EmploymentDataItem.ExtractATO().EmploymentInformation,
        DemographicDataATO: self.DemographicDataModel

      };
      return atoModel;
    };

    self.Submit = function () {
      if (self.AccountViewModel.IsLoggedIn()) {
        self.UpdateNonStudentPortalUser();
      } else {
        self.CreateUserForCE();
      }
    };

    self.UpdateNonStudentPortalUser = function () {
      self.DataLoading(true);
      var tempATO = ko.toJSON(self.ExtractATO());

      var url = sm.portal.utility.formatString(scriptParams.BaseApiUrl + '/api/ContinuingEducation/UpdateNonStudentPortalUser');

      jQuery.ajax({
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: tempATO,
        dataType: 'json',
        url: url,
        processData: true,
        global: true,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        success: function (data, textStatus, jqXHR) {
          var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

          if (data.Status == 'success') {
            self.IsError(false);
          } else if (data.Status === 'validationerror') {
            self.HandleError(container.ValidationTitle, container.ValidationMessages);
          } else if (data.Status === 'error') {
            self.HandleError(container.ValidationTitle, container.ValidationMessages);
          }

          self.DataLoading(false);
          sm.portal.ui.readyPage();
        },
        error: function (jqXHR, exception) {
          if (jqXHR.status === 401) {
            var title = sm.portal.utility.getResourceValue('UnAuthorized');
            var body = sm.portal.utility.getResourceValue('NotAuthorizedToViewPage');
            self.HandleError(title, [body]);
          } else {
            self.HandleError(exception);
          }
          self.DataLoading(false);
        }

      });
    };

    self.CreateUserForCE = function () {
      self.DataLoading(true);
      var tempATO = ko.toJSON(self.ExtractATO());

      var url = sm.portal.utility.formatString(scriptParams.BaseApiUrl + '/api/ContinuingEducation/CreateNonStudentPortalUserAndLogin');

      jQuery.ajax({
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: tempATO,
        dataType: 'json',
        url: url,
        processData: true,
        global: true,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        success: function (data, textStatus, jqXHR) {
          var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

          if (data.Status == 'success') {
            self.IsError(false);
            self.InitializeAndLoginUser(container.Payload, self.UserCreatedSuccessCallback);
          } else if (data.Status === 'validationerror') {
            self.HandleError(container.ValidationTitle, container.ValidationMessages);
          } else if (data.Status === 'error') {
            self.HandleError(container.ValidationTitle, container.ValidationMessages);
          }

          self.DataLoading(false);
          sm.portal.ui.readyPage();
        },
        error: function (jqXHR, exception) {
          if (jqXHR.status === 401) {
            var title = sm.portal.utility.getResourceValue('UnAuthorized');
            var body = sm.portal.utility.getResourceValue('NotAuthorizedToViewPage');
            self.HandleError(title, [body]);
          } else {
            self.HandleError(exception);
          }
          self.DataLoading(false);
        }

      });
    };

    self.InitializeUser = function (container) {
      sm.portal.ui.setSessionCookie('_ViewOnPortal', container.StudentMatriculationGID);

      // Set the appropriate variables
      self.PersonID(container.PersonID);
      self.PersonGID(container.PersonGID);
      self.UserID(container.UserID);
      self.LoginUserName(container.PortalUserName);
      self.PrimaryEmailAddressID(container.PrimaryEmailID);
      self.PrimaryEmailAddressGID(container.PrimaryEmailGID);
    };

    self.InitializeAndLoginUser = function (container, successCallback) {
      self.DataLoading(true);
      self.InitializeUser(container);

      // this is based on the account view model
      var data = 'username=' + encodeURIComponent(self.LoginUserName()) +
                '&password=' + encodeURIComponent(self.AccountViewModel.NewAccountPassword()) +
                '&defaultDomain=U4SM&action=remote_login';

      jQuery.ajax({
        url: _ajaxUri,
        type: 'POST',
        data: data,
        success: function (data, textStatus, jqXHR) {
          var results = jQuery.parseJSON(data);
          if (results.msg === 'success') {
            self.AccountViewModel.GetRequestValidationTokenAndRefreshValue(function () {
              self.AccountViewModel.SetAuthorizationContext(successCallback);
            });
          } else {
            self.HandleError(results.msg);
          }
          self.DataLoading(false);
        },
        error: function (jqXHR, exception) {
          self.HandleError(exception);
          self.DataLoading(false);
        }
      });
    };

    self.CheckForActiveCESAR = function () {
      self.DataLoading(true);

      // Build the standard ATO but att the currently logged in Person ID
      var preID = self.ExtractATO();
      preID.Person.ID(_currentPersonId);
      var tempATO = ko.toJSON(preID);

      var url = sm.portal.utility.formatString(scriptParams.BaseApiUrl + '/api/StudentPortal/VerifyNonStudentPortalUserAndLogin');
      jQuery.ajax({
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: tempATO,
        dataType: 'json',
        url: url,
        processData: true,
        global: true,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        success: function (data, textStatus, jqXHR) {
          var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

          if (data.Status == 'success') {
            self.IsError(false);
            self.InitializeUser(container.Payload);
            self.UserCreatedSuccessCallback();
          } else if (data.Status === 'validationerror') {
            self.HandleError(container.ValidationTitle, container.ValidationMessages);
          } else if (data.Status === 'error') {
            self.HandleError(container.ValidationTitle, container.ValidationMessages);
          }

          self.DataLoading(false);
          sm.portal.ui.readyPage();
        },
        error: function (jqXHR, exception) {
          if (jqXHR.status === 401) {
            var title = sm.portal.utility.getResourceValue('UnAuthorized');
            var body = sm.portal.utility.getResourceValue('NotAuthorizedToViewPage');
            self.HandleError(title, [body]);
          } else {
            self.HandleError(exception);
          }
          self.DataLoading(false);
        }
      });
    };

    self.UserCreatedSuccessCallback = function () {
      sm.portal.ui.setSessionCookie("_ViewReenrollment", true);

      sm.portal.vm.custom.callCustomization('RedirectToCustomPage', null,
        function () {
          window.location = '/index.php/u4sm_page/online-re-enrollment/';            
        }
      );
    };

    /** * VALIDATION METHODS ***/

    self.PrimaryEmailAddress.extend({
      required: {
        params: true,
        message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
      },
      email: {
        message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'Example@domain.com')
      },
      maxLength: {
        params: 250,
        message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
      },
      validation: {
        validator: function (val) {
          var url = _baseApiUri + 'api/studentportal/DuplicatedEmail?email=' + val;

          var duplicatedEmail;

          var successCallback = function (data) {
            duplicatedEmail = data;
          };

          var options = {
            async: false
          };

          sm.portal.utility.AjaxGet(url, successCallback, null, null, options);
          if (duplicatedEmail) { return false; }

          return true;
        },
        message: sm.portal.utility.getResourceValue(smapi.constant.validate_DuplicateEmail_Key)
      }
    });

    self.ConfirmPersonEmailAddress.extend({
      required: {
        params: true,
        message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
      },
      smMatchingValue: {
        params: self.PrimaryEmailAddress,
        message: sm.portal.utility.getResourceValue('EmailDoesNotMatch')
      },
      validation: {
        validator: function (val, valueToCompare) {
          return valueToCompare == val;
        },
        message: sm.portal.utility.getResourceValue('EmailDoesNotMatch'),
        params: self.PrimaryEmailAddress
      },
      email: {
        message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'Example@domain.com')
      },
      maxLength: {
        params: 250,
        message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '250')
      }
    });

    self.CurrentEmployer.extend({
      maxLength: {
        params: 100,
        message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
      }
    });

    self.PersonModel.SIN.extend({
      validation:{
        validator: function(val){return sm.portal.utility.ValidateCanadaSIN(val)},
        message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), '#########'),
        params: self.PersonModel.SIN
      }
    });

    self.ModelErrors = ko.validation.group(this);

    self.IsVMValid = ko.computed(function () {
        return self.SetupOK() &&
               self.PersonModel.GivenName.isValid() &&
               self.PersonModel.Surname.isValid() &&
               (self.AccountViewModel.IsLoggedIn() || (self.AccountViewModel.NewAccountPassword.isValid() &&
               self.AccountViewModel.NewAccountConfirmPassword.isValid())) &&
               self.PrimaryEmailAddress.isValid() && self.ConfirmPersonEmailAddress.isValid() &&
               self.MailingAddressViewModel().IsVMValid() && 
               self.PersonModel.DateOfBirth.isValid() &&
               self.PersonModel.SIN.isValid();;
    }, self);

    self.loadAllCountryTemplates = function () {
      jQuery.blockUI();
      var url = _baseApiUri + 'api/studentportal/getapplicationsection?sectionName=contact&attemptmid='; // TODO: get the correct url
      var promise = jQuery.ajax({
        url: url,
        type: 'GET',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        headers: {
          'x-api-version': '1' //, 
        },
        processData: false,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        success: function (data) {
          if (data.Status === 'success' && data.Payload) {
            var Payload = data.Payload;
            // List Data
            if (Payload.ListData) {
              if (!sm.portal.utility.isNullOrEmpty(Payload.ListData.AllCountry)) {
                ko.mapping.fromJS(Payload.ListData.AllCountry, {}, self.MailingAddressViewModel().Countries);
              }
            }

            // Country Templates
            if (!sm.portal.utility.isNullOrEmpty(Payload.AllCountryTemplates)) {
              ko.mapping.fromJS(Payload.AllCountryTemplates, {}, self.MailingAddressViewModel().AllCountryTemplates);
            }
          }
        },
        complete: function () {
          jQuery.unblockUI();
        }
      });
      return promise;
    };

    var isCountryTemplatesLoaded = false;

    // hacky method to cache country templates
    // todo: move country templates selector to new component or js service as requirejs module
    if (!isCountryTemplatesLoaded) {
      self.loadAllCountryTemplates(self.itemModel).then(function () {
        self.isCountryTemplatesLoaded = true;
      });
    }

    return self;
  }

  jQuery.extend(true, sm.portal.vm.continuingEducation, {
    ContinuingEducationViewModel: ContinuingEducationViewModel
  });
})(jQuery);
